export enum Routes {
  HOMEPAGE_PATH = "/",
  LOGIN_PATH = "/login",
  ADD_FEEDBACK_PATH = "/feedback",
  RELATIONSHIP_MAP_PATH = "/relationship",
  SETTINGS_PATH = "/settings",
  TEAMS_LIST_PATH = "/teams",
  CREATE_TEAM_PATH = "/create-team",
  VIEW_EMPLOYEE_PROFILE_PATH = "/view-profile/:id",
  EMPLOYEE_DETAILS_PATH = "/employee-details/:id"
}
